module.exports = __webpack_public_path__ + "static/media/mdi_upload.7c20c3b0.svg";